export const why_constants = [
  {
    title: "Why Choose Computer Vision Solution",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755251229/powerdbyai/comp-vision-1_fsd7sh.png",
    features: [
      "Automate visual inspection and monitoring tasks",
      "Enhance safety and compliance with real-time detection",
      "Gain insights from unstructured visual data",
      "Reduce manual effort and human error",
      "Scalable solutions for edge, cloud, or on-prem deployment",
    ],
  },
  {
    title: "Applications",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755251229/powerdbyai/comp-vision-2_dmfwag.png",
    features: [
      "Quality control in manufacturing",
      "Facial and object recognition for security and access",
      "License plate and traffic analysis in smart cities",
      "Crop and livestock monitoring in agriculture",
      "Retail shelf analytics and customer movement tracking",
      "Medical imaging support and diagnostics",
    ],
    cta: "Find Your Use Case",
    ctaLink: "/signup",
  },
];
